<template>
  <v-layout row justify-center>
    <v-btn color="primary" dark @click.stop="openDialog"> Nova Cobrança </v-btn>
    <v-flex xs12>
      <v-card-title v-if="newLinkError">
        <v-alert :value="true" color="error" icon="warning" outline>
          <p>Erro ao gerar pagamento!</p>
          <p>Código: {{ response.errors[0].response_code }}</p>
          <p>Detalhe: {{ response.errors[0].response_code_detail }}</p>
        </v-alert>
      </v-card-title>
      <v-card-title v-if="newLinkStatus">
        <v-alert :value="true" color="success" icon="check_circle" outline>
          ✅ Link de pagamento criado com sucesso!
          <br />
          <v-text-field ref="link" v-bind:value="response" readonly />
          <br />
          <v-btn small color="primary" @click="copyTextArea(response)">
            <v-icon left small>content_copy</v-icon>
            Copiar Link
          </v-btn>
          <br /><br />
          <small>💡 A lista será atualizada automaticamente em alguns segundos.</small>
        </v-alert>
      </v-card-title>
    </v-flex>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Cobrança</span>
        </v-card-title>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-text>
            <v-flex xs12>
              <v-text-field
                v-model="name"
                :rules="nameRules"
                label="Nome"
                required
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                required
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model.lazy="value"
                v-money="money"
                label="Valor"
                :rules="valueRules"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="installmentLimit"
                :rules="installmetLimitRules"
                type="number"
                label="Número de parcelas permitido"
                prefix="x"
                required
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="description"
                label="Descrição"
                :rules="descriptionRules"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <h4>Vencimento</h4>
              <br />
              <v-date-picker
                v-model="picker"
                locale="pt-br"
                :landscape="false"
                :reactive="true"
              ></v-date-picker>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog = false"
              >Sair</v-btn
            >
            <v-btn color="blue darken-1" flat @click="validate">Enviar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { changed } from "@/helpers/layout";
import { VMoney } from "v-money";

export default {
  data: () => ({
    resp: null,
    paylink: [],
    dialog: false,
    picker: new Date().toISOString().substr(0, 10),
    valid: true,
    name: "",
    email: "",
    installmentLimit: "",
    description: "",
    value: "",
    nameRules: [(v) => !!v || "Nome é requirido"],
    valueRules: [(v) => !!v || "Valor deve ser válido"],
    installmetLimitRules: [
      (v) => !!v || "limite de parcelas deve ser válido",
      (v) => (v && v >= 1) || "Parcela minima = 1x",
      (v) => (v && v <= 12) || "Parcela máxima = 12x",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail é requirido",
      (v) => /.+@.+/.test(v) || "E-mail precisa ser válido",
    ],
    descriptionRules: [
      (v) => !!v || "Descrição é requirida",
      (v) =>
        (v && v.length >= 10) || "Descrição precisa ser maior 10 caracteres",
    ],
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false,
    },
  }),
  directives: { money: VMoney },
  mounted() {
    this.$store.commit("invoices/LOADING_DATA", false);
  },
  computed: {
    ...mapGetters({
      response: "invoices/link",
      isLoading: "invoices/loadingData",
      newLinkError: "invoices/newLinkError",
      newLinkStatus: "invoices/newLinkStatus",
      filters: "invoices/filter",
    }),
  },
  watch: {
    newLinkStatus(newValue) {
      if (newValue === true) {
        // Limpar o formulário após sucesso
        this.resetForm();
        
        // Fechar o alerta de sucesso após 5 segundos
        setTimeout(() => {
          this.$store.commit("invoices/NEW_LINK_STATUS", false);
        }, 5000);
      }
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.paylink = {
          name: this.name,
          email: this.email,
          amount: this.value.replace(".", ""),
          installment_limit: this.installmentLimit,
          description: this.description,
          duedate: this.picker,
        };
        // console.log(this.paylink);
        this.$store.dispatch("invoices/getLink", this.paylink);
        this.dialog = false;
      }
    },
    openDialog() {
      this.dialog = true;
      this.alert = false;
    },
    updatePage() {
      window.location.reload();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    resetForm() {
      // Limpar todos os campos do formulário
      this.name = "";
      this.email = "";
      this.value = "";
      this.installmentLimit = "";
      this.description = "";
      this.picker = new Date().toISOString().substr(0, 10);
      
      // Reset da validação do formulário
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    copyLink(link) {
      let copyText = link;
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      alert("Link copiado: " + copyText);
    },
    copyTextArea(link) {
      // Tentar usar a API moderna de clipboard primeiro
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(link).then(() => {
          this.$store.commit('invoices/NEW_LINK_STATUS', false);
          this.showSuccessMessage('Link copiado com sucesso! ✅');
        }).catch(() => {
          this.fallbackCopyToClipboard(link);
        });
      } else {
        this.fallbackCopyToClipboard(link);
      }
    },
    fallbackCopyToClipboard(link) {
      const el = document.createElement("textarea");
      el.value = link;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand("copy");
        this.showSuccessMessage('Link copiado com sucesso! ✅');
      } catch (err) {
        alert("Erro ao copiar. Tente selecionar o texto manualmente.");
      }
      document.body.removeChild(el);
    },
    showSuccessMessage(message) {
      // Aqui poderia usar um toast ou snackbar, mas vamos usar alert por simplicidade
      alert(message);
    },
  },
};
</script>
